import { FeatureFlag, useFeatureFlagValue } from "../../feature-flags";

/**
 * Whether the deployment-environment ribbon (`EnvironmentBanner`) renders on
 * onboarding routes. Requires the parent `enable-onboarding` gate (see
 * `OnboardingLayout`); this flag only controls the ribbon itself.
 *
 * Defaults to off when LaunchDarkly has no value; turn on
 * `enable-onboarding-environment-banner` in LD where the ribbon should appear.
 */
export function useOnboardingEnvironmentBannerEnabled(): boolean {
  return useFeatureFlagValue(FeatureFlag.EnableOnboardingEnvironmentBanner);
}
